module.exports = __webpack_public_path__ + "static/media/DSC_0170.bb11e7fb.jpg";